import { RewardResetCadence } from '@pages/RewardsHub/RewardHubDto'

export interface TimeRemaining {
  days: number
  hours: number
  minutes: number
}

export const useRewardCadenceCalculation = (resetCadenceId: number, now: Date = new Date()) => {
  const getNextDailyReset = (now: Date) => {
    return new Date(
      Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1, 0, 0, 0, 0)
    )
  }
  const getNextWeeklyReset = (now: Date) => {
    const dayOfWeek = now.getUTCDay()
    let daysUntilMonday = (8 - dayOfWeek) % 7
    if (daysUntilMonday === 0) daysUntilMonday = 7

    return new Date(
      Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate() + daysUntilMonday,
        0,
        0,
        0,
        0
      )
    )
  }

  const getNextMonthlyReset = (now: Date) => {
    return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() + 1, 1, 0, 0, 0, 0))
  }

  const getNextQuarterlyReset = (now: Date) => {
    const currentMonth = now.getUTCMonth() // 0-11
    const currentQuarterStartMonth = Math.floor(currentMonth / 3) * 3
    const nextQuarterStartMonth = currentQuarterStartMonth + 3

    return new Date(Date.UTC(now.getUTCFullYear(), nextQuarterStartMonth, 1, 0, 0, 0, 0))
  }

  const getNextAnnualReset = (now: Date) => {
    return new Date(Date.UTC(now.getUTCFullYear() + 1, 0, 1, 0, 0, 0, 0))
  }

  const breakDownUpToMins = (difference: number | null): TimeRemaining => {
    if (difference == null || difference < 0) {
      return { days: 0, hours: 0, minutes: 0 }
    }

    const totalMinutes = Math.round(difference / 60000)
    const days = Math.floor(totalMinutes / 1440)
    const hours = Math.floor((totalMinutes % 1440) / 60)
    const minutes = totalMinutes % 60

    return { days, hours, minutes }
  }

  const getNextResetDate = (cadenceId: number, now: Date) => {
    switch (cadenceId) {
      case RewardResetCadence.DAILY:
        return getNextDailyReset(now)
      case RewardResetCadence.WEEKLY:
        return getNextWeeklyReset(now)
      case RewardResetCadence.MONTHLY:
        return getNextMonthlyReset(now)
      case RewardResetCadence.QUARTERLY:
        return getNextQuarterlyReset(now)
      case RewardResetCadence.ANNUALLY:
        return getNextAnnualReset(now)
      case RewardResetCadence.LIFETIME:
        return null
      default:
        return null
    }
  }

  const nextResetDate = getNextResetDate(resetCadenceId, now)
  const difference = nextResetDate ? nextResetDate.getTime() - now.getTime() : null

  return {
    nextResetDate,
    timeRemaining: breakDownUpToMins(difference),
  }
}
